import { render, staticRenderFns } from "./membership.vue?vue&type=template&id=0bbcc867&scoped=true&"
import script from "./membership.vue?vue&type=script&lang=js&"
export * from "./membership.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bbcc867",
  null
  
)

export default component.exports